/* template */
<template><Popup :show="(show)" :closeable="(false)"><div class="success-wrap"><mpx-image :src="(shineImg)" mode="widthFix" class="shine-image"/><template v-if="(type===1)"><div class="update head"><mpx-image :src="(congratulateImg)" class="congratulate-image"/><mpx-image :src="(speedImg)" class="speed-image"/></div><div class="update content"><div class="from"><div class="title">{{curScramebleStatus.pre_status_name}}</div><div class="text">领先{{curScramebleStatus.pre_percent}}%的用户</div></div><mpx-image :src="(arrowImg)" mode="widthFix" class="arrow-image"/><div class="to"><div class="title">{{curScramebleStatus.status_name}}</div><hl-text :text="(toSpeed.text)" :commonStyle="(toSpeed.commonStyle)" :hlStyle="(toSpeed.hlStyle)" :hlColor="(toSpeed.hlColor)" class="text"/></div></div></template><template v-if="(type===2)"><div class="help head"><div class="title"><div class="num">2</div><mpx-image :src="(numSpeedImg)" mode="widthFix" class="num-speed-image"/></div><div class="tips">领先65%的抢票用户</div></div><div class="help content"><div v-for="(item, index) in (list)" :style="[(photoItemStyle)] | transRpxStyle" class="photo"></div></div></template><mpx-view @tap="close" class="btn"><div class="btn-text">我知道了</div></mpx-view></div></Popup></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m51283d9e"}'>
.success-wrap
  width 240px
  height 320px
  background-image url('https://ut-static.udache.com/webx/sfc/cRmg_lsrDAvyRDw7coMbC.png') 
  background-size contain
  background-repeat no-repeat
  position relative
  padding 0px 20px 24px 20px
  display flex
  flex-direction column
  justify-content space-between
  border-radius: 20px;
.shine-image
  width: 445px;
  width 130vw
  position absolute
  top 50%
  left 50%
  transform translate(-50%, -50%)
  z-index -1
.update.head
  display flex
  flex-direction column
  .congratulate-image
    width 99px
    height 24px
    margin-top 39px
  .speed-image
    width 149px
    height 24px
    margin-top 9px
.update.content
  display flex
  align-items flex-end
  justify-content center
  position relative
  .from
    color: #3BB6A2;
    width: 110px;
    height: 95px;
    border-radius: 10.155px;
    background: #C2EEE5;
    box-sizing: border-box;
    border: 1px solid #98D6BA;
    display flex
    flex-direction column
    align-items center
    justify-content center
    .title
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
    .text
      font-family: PingFang SC;
      font-size: 11px;
      font-weight: 500;
      line-height: 10px;
      margin-top 15px
  .to
    color: #FFFFFF;
    width: 130px;
    height: 110px;
    border-radius: 10.155px;
    background: linear-gradient(332deg, #FF5900 5%, #FF8C00 86%);
    margin-left -12px
    display flex
    flex-direction column
    align-items center
    justify-content center
    .title
      font-family: PingFang SC;
      font-size: 22px;
      font-weight: 600;
      line-height: 24px;
    .text
      margin-top 9px
      display flex
      flex-direction row
      align-items baseline
  .arrow-image
    width 43px
    height 30px
    position absolute
    bottom -15px
    transform translate(-15px,0)
.help.head
  display flex
  flex-direction column
  .title
    display flex
    flex-direction row
    align-items flex-end
    margin-top 27px
    .num
      font-family: Barlow Semi Condensed;
      font-size: 30px;
      font-weight: bold;
      line-height: 30px;
      color: #051C14;
      margin-right 1px
    .num-speed-image
      width: 124px;
      height: 24px;
      margin-bottom 2px
  .tips
    margin-top 9px  
.help.content
  display flex
  align-items flex-end
  justify-content center
  position relative
  .photo
    border: 3px solid #FFFFFF;
    border-radius 50% 
    width: 80px;
    height: 80px;
    background-color #FFFFFF
    .photo-img
      width: 80px;
      height: 80px;  
.btn
  height: 45px;
  border-radius: 12px;
  background: #FF5900;
  margin-bottom:10px;
  .btn-text
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 45px;
    text-align: center;
    color: #FFFFFF;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m51283d9e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./success-popup.mpx.js?isComponent&outputPath=components%2Fsuccess-popup51283d9e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./success-popup.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fsuccess-popup51283d9e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m51283d9e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/success-popup51283d9e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Popup':getComponent(require("../../../../../node_modules/@didi/spring-ui/ts-popup/index.mpx?isComponent&outputPath=components%2Findex0ce21716%2Findex")),'hl-text':getComponent(require("../../../../components/hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
